import { useQuery } from '@tanstack/react-query';
import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { AuthUser } from '../types';

export interface MeResponse {
  status: number;
  msg: string;
  data: AuthUser;
}

export const me = (): Promise<MeResponse> => {
  return axios.post('/info');
};

type QueryFnType = typeof me;

type useMeOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useMe = ({ config }: useMeOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['me'],
    queryFn: () => me(),
    ...config,
  });
};
